import {
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';
import { Destroyer } from 'app/common/utils';
import { ColorThemeService } from 'app/common/services/color-theme.service';
import { takeUntil } from 'rxjs/operators';
import { ThemeColor } from 'app/common/enums/theme-color.enum';
import { AppStore } from '@iv/store/app.store';
import * as Redux from 'redux';
import { AppState } from '@iv/store/app.reducer';
import {
  interval,
  Subscription,
  timer
} from 'rxjs';
import { generateId } from '@iv/shared/helpers/common.helper';
import {
  Future,
  Instrument
} from '@iv/model/instrument';
import {PaymentWindowService} from '../../../payment-window.service';

declare var zingchart: any;

@Component({
  selector: 'iv-live-zing-chart',
  template: '<ng-content></ng-content>'
})
export class ZingChartComponent extends Destroyer implements OnInit, OnDestroy {

  constructor(
    protected readonly colorThemeService: ColorThemeService,
    @Inject(AppStore) protected readonly store: Redux.Store<AppState>,
    protected readonly paymentWindowService: PaymentWindowService
  ) {
    super();

    this.changeTheme(this.colorThemeService.getColorTheme());
  }

  public theme: ThemeColor;
  public chartId: string = generateId();
  protected isChartInitialized = false;

  protected backgroundColor: string;
  protected lineColor: string;

  protected _instrument: Instrument & Future = null;
  public get instrument(): Instrument & Future {
    return this._instrument;
  }

  @Input()
  public set instrument(value: Instrument & Future) {
    this._instrument = value;
  }

  @Input()
  public tabType: string;

  public ngOnInit(): void {
    this.paymentWindowService.showPaymentWindow();
    this.colorThemeService.$colorTheme
      .pipe(takeUntil(this.destroy$))
      .subscribe((colorTheme: ThemeColor) => {
        this.changeTheme(colorTheme);
      });

    this.getChartData()
    interval(20000).pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.getChartData()
    })
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  protected changeTheme(colorTheme: ThemeColor): void {
    this.theme = colorTheme;
    console.log(this.theme, 'theme was chosen')
    if (colorTheme === ThemeColor.DARK) {
      this.backgroundColor = '#22313d';
      this.lineColor = '#fff';
    } else {
      this.backgroundColor = '#fff';
      this.lineColor = '#22313d';
    }
    this.reRenderChart();
  }

  protected reRenderChart(): void {
    zingchart.exec(this.chartId, 'setdata', {
      data: this.getChartConfig
    });
  }

  protected renderChart(): void {
    zingchart.THEME = 'classic';
    zingchart.render({
      id: this.chartId,
      data: this.getChartConfig,
      height: '100%'
    });
  }

  protected get getChartConfig(): Object {
    return {};
  }

  protected getChartData(): void {
  }
}
